import { put, take } from 'redux-saga/effects'
import * as actions from '../actions/chatActions';

/*
 * This Listener is to be used for every /topic queue we subscribe to
 */

export const channelHandler = (emit, message) =>
  emit(actions.messageReceived(JSON.parse(message.body)));

/*
 * behaves very much like 'takeEvery'
 */
export function* channelRead(queue) {
  while (true) {
    const action = yield take(queue);
    yield put(action);
  }
}
